import EventEmitter from './EventEmitter';
import {Router_state} from '../../@types/shared';
import DomU, {$} from './DomU';
import u_parseUrl from '../utils/u_parseUrl';

const getState = () => {
  const url = '/' + location.href.split('/').slice(3).join('/');
  const dir = (url.split('?')[0] || '').split('#')[0];
  const query = (url.split('?')[1] || '').split('#')[0];
  const path = dir + (query ? `?${query}` : '');
  const hash = url.split('#')[1] || '';
  return {url, dir, path, query, hash};
};

export default new class Router extends EventEmitter {
  get initialState(): Router_state {
    return this._initialState;
  }

  public e = {
    change: 'change',
  };

  private _initialState: Router_state;
  private _state: Router_state;
  private $body: DomU;
  private $window: DomU;

  setup() {
    this.$body = $(document.body);
    this.$window = $(window);
    this.$window.on('popstate', this._popstateHdl.bind(this));
    this._initialState = getState();
    this._popstateHdl();
    this.$body.on('click', this._bodyClickHdl.bind(this));
  }

  get state(): Router_state {
    return this._state;
  }

  change(url: string, option: { replace: boolean }) {
    if (!url) url = this._initialState.path;
    if (option.replace) history.replaceState('', '', url);
    else history.pushState('', '', url);
    this._popstateHdl();
  }

  back() {
    history.back();
  }

restoreInitial(option:{withHash:boolean, replace:boolean}) {
    const {path, hash} = this._initialState;
    const url = path + ((hash && option.withHash) ? `#${hash}` : '');
    this.change(url, {replace: option.replace});
  }

  _popstateHdl() {
    const state = getState();
    if (this._state && this._state.url === state.url) return;
    this._state = state;
    if (this._initialState.path === state.path) this._initialState.hash = state.hash;//最初にアクセスしたURLでのhash変更をinitialに反映しちゃう（モーダルから戻るときなどに）
    this.emit(this.e.change);
  }

  _bodyClickHdl(e: Event) {
    const $a = $(e.target);
    const href = $a.attr('href') || $a.attr('data-href') || '';
    if (!$a.hasClass('js-routerButton')) return;
    if ($a.attr('target') === '_blank') return;

    //条件次第で有効（それ以外では通常のリンク）
    if ($a.attr('data-enableCondition')) {
      const replaceCondition = u_parseUrl('?' + $a.attr('data-enableCondition')).query;
      let hit = true;
      for (let key in replaceCondition) {
        if (this._state[key] !== replaceCondition[key]) hit = false;
      }
      if (!hit) return;
    }

    //
    e.preventDefault();
    e.stopPropagation();

    const replace = parseInt($a.attr('data-replace')) === 1;
    this.change(href, {replace});
  }

}();
